import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Joins class names and lets later Tailwind classes win, as in S's components. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
